import { useMemo } from 'react';
import { useGetPtoRdEditsAccessQuery, useMeQuery, type PtoRdEditsAccess } from '@shared/api';
import { useAgentPermission } from '@entities/user';
import { rdEditRights, type RdEditRights } from './logic';

/** Доступ к правкам РД «Инженер+» (№8) в проекте. */
export interface RdVolumeEditAccess extends RdEditRights {
  /** Ответ сервера: справочники причин и видов документов, лимит файла;
   *  null — ещё не загружен или сервер без правок. */
  access: PtoRdEditsAccess | null;
  /** id текущего пользователя — автор строки не подтверждает её сам. */
  me: string | null;
  canWrite: boolean;
}

/**
 * Права на правки РД в проекте: флаг `OSNOVA_PTO_RD_EDITS_ENABLED` (off | test
 * | on), роль не ниже «Инженер+» и запись в проект — по
 * `GET /projects/{id}/rd-edits/access`. Пока ответа нет (или сервер старый) —
 * правок нет: экран ведёт себя как до выпуска 4. Окно листа РД (№9) берёт права
 * этим же хуком.
 */
export function useRdVolumeEditAccess(projectId: string | null | undefined): RdVolumeEditAccess {
  const { can_write } = useAgentPermission('pto');
  const { data } = useGetPtoRdEditsAccessQuery(projectId ?? '', { skip: !projectId });
  const me = useMeQuery().data?.user.id ?? null;
  return useMemo(
    () => ({ ...rdEditRights(data, can_write), access: data ?? null, me, canWrite: can_write }),
    [data, can_write, me],
  );
}
